/**
 * @module taxTypes
 * @description A list of taxTypes
 */

export const taxTypes = ['sales', 'purchase', 'payroll', 'other'] as const;
export type TaxTypes = (typeof taxTypes)[number];
